// extracted by mini-css-extract-plugin
export default {"summary-container":"iEE81P_XcN0qDGEl8HEc","summary-item":"BRkJ7pPZZxLus9o5nA3X"};